/** Snapshot key holding the sync manager's refKey → resolved-id map. */
export const IDMAP_SNAPSHOT_KEY = 'idmap';

// Sync-state snapshots a cache refresh must never drop: losing the idmap
// strands a create whose uploads already succeeded and deleted their blobs.
export const PROTECTED_SNAPSHOT_KEYS: ReadonlySet<string> = new Set([
  IDMAP_SNAPSHOT_KEY,
]);
